require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-comments-on-aiibs-draft-complaints-handling-mechanism.json") })
        }
      }, "path---en-us-update-comments-on-aiibs-draft-complaints-handling-mechanism");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-comments-on-aiibs-draft-complaints-handling-mechanism!./.cache/json/en-us-update-comments-on-aiibs-draft-complaints-handling-mechanism.json
// module id = 646
// module chunks = 231608221292675